<template>
    <page title="finisherNumbers" :textHeight="(WindowSize.y - 276) + 'px'">
        <template #pageContainer v-if="!!Competition">
			<v-form ref="form" v-model="valid">
				<v-row><v-col>
					<p>{{ $t(`text.compApprovalFinisherHint1`) }}</p>
					<b><p>{{ $t(`text.compApprovalFinisherHint2`, { LV: Competition.eventLocation_RegionName }) }}</p></b>
				</v-col></v-row>
				<v-row>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Women_Active"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Women_Active')"
							@blur="calcSum('finisher_Women_Active')"
							:label="$t('text.competitionGroups.w')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Women_U2018"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Women_U2018')"
							@blur="calcSum('finisher_Women_U2018')"
							:label="$t('text.competitionGroups.w20')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Women_U1614"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Women_U1614')"
							@blur="calcSum('finisher_Women_U1614')"
							:label="$t('text.competitionGroups.w16')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Women_U12"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Women_U12')"
							@blur="calcSum('finisher_Women_U12')"
							:label="$t('text.competitionGroups.w12')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Women_Masters"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Women_Masters')"
							@blur="calcSum('finisher_Women_Masters')"
							:label="$t('text.competitionGroups.wsen')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							readonly
							type="number"
							v-model="sumW"
							:label="$t('text.sum')">
						</v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Men_Active"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Men_Active')"
							@blur="calcSum('finisher_Men_Active')"
							:label="$t('text.competitionGroups.m')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Men_U2018"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Men_U2018')"
							@blur="calcSum('finisher_Men_U2018')"
							:label="$t('text.competitionGroups.m20')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							@focus="resetField('finisher_Men_U1614')"
							@blur="calcSum('finisher_Men_U1614')"
							v-model.number="finisher.finisher_Men_U1614"
							:rules="[rules.minZero]"
							:label="$t('text.competitionGroups.m16')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Men_U12"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Men_U12')"
							@blur="calcSum('finisher_Men_U12')"
							:label="$t('text.competitionGroups.m12')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.finisher_Men_Masters"
							:rules="[rules.minZero]"
							@focus="resetField('finisher_Men_Masters')"
							@blur="calcSum('finisher_Men_Masters')"
							:label="$t('text.competitionGroups.msen')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							readonly
							type="number"
							v-model="sumM"
							:label="$t('text.sum')">
						</v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="10" lg="10">
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							readonly
							type="number"
							v-model="sumOA"
							:label="$t('text.sumOverAll')">
						</v-text-field>
					</v-col>
				</v-row>
				<v-row><v-col>
					<p>{{ $t(`text.compApprovalFinisherHint3`) }}</p>
				</v-col></v-row>
				<v-row>
					<v-col cols="12" sm="3" lg="3">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.totalSum_Runners"
							:rules="[rules.minZero]"
							@focus="resetField('totalSum_Runners')"
							@blur="calcSum('totalSum_Runners')"
							:label="$t('text.competitionGroups.sumRun')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="3" lg="3">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.totalSum_Others"
							:rules="[rules.minZero]"
							@focus="resetField('totalSum_Others')"
							@blur="calcSum('totalSum_Others')"
							:label="$t('text.competitionGroups.sumInline')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="3" lg="3">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							type="number"
							v-model.number="finisher.totalSum_Walker"
							:rules="[rules.minZero]"
							@focus="resetField('totalSum_Walker')"
							@blur="calcSum('totalSum_Walker')"
							:label="$t('text.competitionGroups.sumNordic')">
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="1" lg="1">
					</v-col>
					<v-col cols="12" sm="2" lg="2">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							readonly
							type="number"
							v-model="sumOA2"
							:rules="[rules.sameAsOA]"
							:label="$t('text.sumOverAll')">
						</v-text-field>
					</v-col>
				</v-row>
				<v-row><v-col>
					<p>{{ $t(`text.compApprovalFinisherHint4`) }}</p>
				</v-col></v-row>
				<v-row><v-col>
					<v-radio-group v-model="contactAddress" :mandatory="true" @change="onRadioChange">
						<v-radio :label="getCompetitionContact" value="0"></v-radio>
						<v-radio :label="$t(`text.otherContact`)" value="2"></v-radio>
					</v-radio-group>
				</v-col></v-row>
				<template>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="finisher.billing_ClubCompany"
						:label="$t('text.headerOrganization')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						v-model="finisher.billing_Titel"
						:items="title.items"
						:label="$t('text.title')+'*'">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="finisher.billing_Firstname"
						:label="$t('text.firstName')+'*'"
						:rules="[rules.notEmpty]">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="finisher.billing_Lastname"
						:label="$t('text.lastName')+'*'"
						:rules="[rules.notEmpty]">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="finisher.billing_Street"
						:label="$t('text.streetNr')+'*'"
						:rules="[rules.notEmpty]">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col cols="12"  sm="4" lg="4">
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="finisher.billing_Zip"
						:label="$t('text.zip')+'*'"
						:rules="[rules.notEmpty]">
					</v-text-field>
				</v-col><v-col cols="12"  sm="8" lg="8">
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="finisher.billing_Town"
						:label="$t('text.place')+'*'"
						:rules="[rules.notEmpty]">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						clearable
						v-model="finisher.billing_Mail"
						:label="$t('text.email')+'*'"
						:rules="[rules.notEmpty, rules.email]">
					</v-text-field>
				</v-col></v-row>
				</template>
				<v-row v-if="!competitionPassed(Competition.startDate)">
					<v-col>
						<v-alert type="error">
							{{$t(`text.competitionNotPassed`)}}
						</v-alert>
					</v-col>
				</v-row>
				<v-row v-if="!!Competition.billing_Filename">
					<v-col>
						<v-alert type="error">
							{{$t(`text.competitionFinisherRecorded`)}}
						</v-alert>
					</v-col>
				</v-row>

				<v-row><v-col>
				</v-col></v-row>
            </v-form>
        </template>
		<template #pageActions v-if="!!Competition">
			<v-row>
				<v-col>
					<v-btn
						class="mr-4"
						:disabled="loading || !competitionPassed(Competition.startDate) || !!Competition.billing_Filename"
						@click="save">
						{{ $t(`text.save_and_send`) }}
					</v-btn>
					<v-btn
						:disabled="loading"
						class="mr-4"
						@click="back">
						{{ $t(`text.backButton`) }}
					</v-btn>
				</v-col>
			</v-row>
        </template>
		<spinner :loading="loading || !!Competition"></spinner>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import compApprovalActions from '../store/actions/compApproval';
import namespace from '../store/namespace';

import getAllowedFormats from '../models/allowedFormats';
import getAttachmentTypes from '../models/attachmentType';
import getFileGroups from '../models/fileGroups';
import modelState from '../mixins/modelState';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

export default {
	name: 'CompetitionApprovalFinisher',
	mixins: [modelState],
	components: {
		Page,
		Spinner,
	},
	data() {
		return {
			valid: true,
			loading: false,
			sumW: 0,
			sumM: 0,
			sumOA: 0,
			sumOA2: 0,
			title: {
				items: [{ text: this.$i18n.t('text.mr'), value: 0 }, { text: this.$i18n.t('text.mrs'), value: 1 }, { text: this.$i18n.t('text.none'), value: 2 }, { text: this.$i18n.t('text.company'), value: 3 }],
			},
			contactAddress: '0',
			finisher: {
				billing_ClubCompany: '',
				billing_Firstname: '',
				billing_Lastname: '',
				billing_Mail: '',
				billing_Street: '',
				billing_Zip: '',
				billing_Town: '',
			},
			rules: {
				notEmpty: v => (v !== null && v !== undefined && v !== '') || this.$i18n.t('text.errorEmpty'),
				minZero: v => v >= 0 || this.$i18n.t('text.errorMinZero'),
				sameAsOA: v => v === this.sumOA || this.$i18n.t('text.errorSum'),
				email: v => /.+@.+\..+/.test(v) || this.$i18n.t('text.errorInvalidEmail'),
			},
		};
	},
	async mounted() {
		this.loading = true;
		if (this.CompApprLinks.length === undefined || this.CompApprLinks.length === 0) {
			await this.GET_COMP_APPROVAL_LINKS();
		}


		if (!this.Competition || this.Competition.id !== this.cGuid) {
			const link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
			if (link) {
				await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
				this.onRadioChange();
				this.readFromDTO();
				this.calcSum();
			}
		} else {
			this.onRadioChange();
			this.readFromDTO();
			this.calcSum();
		}


		this.loading = false;
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITIONAPPROVAL, ['CompApprLinks', 'Competition']),
		cGuid() {
			return this.$route.params.cGuid || null;
		},
		allowedFormats() {
			return getAllowedFormats(this);
		},
		attachmentType() {
			return getAttachmentTypes(this);
		},
		fileGroups() {
			return getFileGroups(this);
		},
		getCompetitionContact() {
			return `${this.Competition.contact_Firstname}
					${this.Competition.contact_Lastname},
					${this.Competition.contact_Email}
					${this.Competition.contact_Street || ''}
					${this.Competition.contact_Zip || ''}
					${this.Competition.contact_Town || ''} 
					(${this.$t('text.competitionContact')})`;
		},
	},
	methods: {
		...mapActions(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.GET_COMP_APPROVAL_LINKS,
			compApprovalActions.GET_COMP_BY_ID,
			compApprovalActions.SEND_FINISHER,
		]),
		competitionPassed(date) {
			const today = new Date();
			const cDate = new Date(date);
			return today >= cDate;
		},
		resetField(field) {
			if (this.finisher[field] === 0) this.finisher[field] = null;
		},
		onRadioChange() {
			if (this.contactAddress === '0') {
				this.finisher.billing_ClubCompany = this.Competition.ownerOrganizationName;
				this.finisher.billing_Titel = this.Competition.billing_Titel;
				this.finisher.billing_Firstname = this.Competition.contact_Firstname;
				this.finisher.billing_Lastname = this.Competition.contact_Lastname;
				this.finisher.billing_Mail = this.Competition.contact_Email;
				this.finisher.billing_Street = this.Competition.contact_Street;
				this.finisher.billing_Zip = this.Competition.contact_Zip;
				this.finisher.billing_Town = this.Competition.contact_Town;
			} else if (this.contactAddress === '2') {
				this.finisher.billing_ClubCompany = '';
				this.finisher.billing_Titel = 0;
				this.finisher.billing_Firstname = '';
				this.finisher.billing_Lastname = '';
				this.finisher.billing_Mail = '';
				this.finisher.billing_Street = '';
				this.finisher.billing_Zip = '';
				this.finisher.billing_Town = '';
			}
		},
		calcSum(field) {
			if (field && this.finisher[field] === null) this.finisher[field] = 0;
			this.sumW = this.finisher.finisher_Women_Active + this.finisher.finisher_Women_U2018 + this.finisher.finisher_Women_U1614 + this.finisher.finisher_Women_U12 + this.finisher.finisher_Women_Masters;
			this.sumM = this.finisher.finisher_Men_Active + this.finisher.finisher_Men_U2018 + this.finisher.finisher_Men_U1614 + this.finisher.finisher_Men_U12 + this.finisher.finisher_Men_Masters;
			this.sumOA = this.sumW + this.sumM;
			this.sumOA2 = this.finisher.totalSum_Runners + this.finisher.totalSum_Others + this.finisher.totalSum_Walker;
			this.$refs.form.validate();
		},
		readFromDTO() {
			this.finisher.finisher_Men_Active = this.Competition.finisher_Men_Active;
			this.finisher.finisher_Men_Masters = this.Competition.finisher_Men_Masters;
			this.finisher.finisher_Men_U12 = this.Competition.finisher_Men_U12;
			this.finisher.finisher_Men_U1614 = this.Competition.finisher_Men_U1614;
			this.finisher.finisher_Men_U2018 = this.Competition.finisher_Men_U2018;
			this.finisher.finisher_Women_Active = this.Competition.finisher_Women_Active;
			this.finisher.finisher_Women_Masters = this.Competition.finisher_Women_Masters;
			this.finisher.finisher_Women_U12 = this.Competition.finisher_Women_U12;
			this.finisher.finisher_Women_U1614 = this.Competition.finisher_Women_U1614;
			this.finisher.finisher_Women_U2018 = this.Competition.finisher_Women_U2018;
			this.finisher.totalSum_Runners = this.Competition.totalSum_Runners;
			this.finisher.totalSum_Others = this.Competition.totalSum_Others;
			this.finisher.totalSum_Walker = this.Competition.totalSum_Walker;
		},
		async create() {
			this.loading = true;

			if (this.valid) {
				let link = null;
				link = this.CompApprLinks.find(x => x.rel === 'send_finishers');

				if (link) {
					try {
						this.modelState = {};
						await this.SEND_FINISHER({ link, cGuid: this.cGuid, finisher: this.finisher });
					} catch (e) {
						console.log(e);
						if (e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
			}
			this.loading = false;
		},
		async save() {
			this.$refs.form.validate();
			if (this.valid) {
				try{
					await this.create();
					this.$router.push({ name: 'competitionapproval' });
				}
				catch (e) {
						console.log(e);						
						throw new Error('Diese Änderung ist nur mehr in LaNet3 möglich!');
						}
				
			} else if (!this.valid && this.$refs.form.errorBag) {
				const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
				if (id) document.getElementById(`input-${id}`).scrollIntoView();
			}
		},
		back() {
			this.$router.go(-1);
		},
	},
};
</script>
